var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.isPreOrdering && _vm.suiteCateringOrder)?_c('confirmation-pre-order',{attrs:{"suite-catering-order":_vm.suiteCateringOrder},on:{"switchToCart":_vm.switchToCart,"close":_vm.close}}):_c('confirmation-order',{on:{"order-completed":function($event){return _vm.$emit('order-completed')},"close":_vm.close}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }